module.exports = __webpack_public_path__ + "static/media/12UNCTAD11.5c25dc7a.jpg";